import { render } from "./Questionnaire.vue?vue&type=template&id=fa2e9184&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"

import "./Questionnaire.vue?vue&type=style&index=0&id=fa2e9184&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2e9184"]])

export default __exports__